import React from 'react';
import { Link } from 'react-router-dom';
import { CALENDLY_URL, CALENDLY_READY } from '../config';

/**
 * Opens the Calendly popup overlay (visitor never leaves the site).
 * Falls back to navigating to /contact if Calendly hasn't been
 * configured yet or the widget script failed to load.
 */
const openCalendly = (e) => {
  if (!CALENDLY_READY) return; // Allow the underlying Link to /contact to run
  const Cal = typeof window !== 'undefined' ? window.Calendly : null;
  if (!Cal || typeof Cal.initPopupWidget !== 'function') return;
  e.preventDefault();
  Cal.initPopupWidget({
    url: CALENDLY_URL,
    prefill: {},
    utm: { utmSource: 'keystone-website' },
  });
};

const BookDemoButton = ({ className = '', children, testid }) => (
  <Link
    to="/contact"
    onClick={openCalendly}
    data-testid={testid || 'book-demo-button'}
    className={className}
  >
    {children}
  </Link>
);

export default BookDemoButton;
